// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36yaP","largestCol":"styles_largestCol__2deCi","smallestCol":"styles_smallestCol__1oPKf"};